import { apolloClient } from '~/apollo-client';
import {
  GetUserDocuSignEnvelopesQuery,
  GetUserDocuSignEnvelopesQueryVariables,
} from '~/typings/graphql';
import { trackError } from '~/utils/tracking';
import { GET_USER_DOCUSIGN_ENVELOPES_QUERY } from './user-docusign-envelope.queries';

const getUserDocusignEnvelopes = async (userId: number) => {
  if (!userId) {
    return null;
  }
  try {
    const { data } = await apolloClient.query<
      GetUserDocuSignEnvelopesQuery,
      GetUserDocuSignEnvelopesQueryVariables
    >({
      query: GET_USER_DOCUSIGN_ENVELOPES_QUERY,
      variables: { userId },
    });
    return data;
  } catch (error) {
    trackError(error);
    return null;
  }
};

export { getUserDocusignEnvelopes };
